import React from "react";

export default function Confirmation({ submittedData, onNewRequest, onViewHistory }) {
  const {
    transactionNumber,
    displayName,
    userPrincipalName,
    lastDay,
    delegates,
    dateSubmitted,
    executionStatus,
    actionLog,
  } = submittedData || {};

  const formatDate = (iso) => {
    if (!iso) return "—";
    return new Date(iso).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const statusClass =
    executionStatus === "Completed"
      ? "status-badge status-completed"
      : executionStatus === "Failed"
      ? "status-badge status-failed"
      : "status-badge status-pending";

  return (
    <div className="confirmation-page">
      <div className="confirmation-card">
        <div className="confirmation-icon">
          <svg width="56" height="56" viewBox="0 0 56 56" fill="none">
            <circle cx="28" cy="28" r="28" fill="#230658" fillOpacity="0.1" />
            <circle cx="28" cy="28" r="22" fill="#230658" fillOpacity="0.15" />
            <circle cx="28" cy="28" r="16" fill="#230658" />
            <path
              d="M20 28L25 33L36 22"
              stroke="white"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        <h2>Request Submitted</h2>
        <p className="confirmation-subtitle">
          The offboarding request has been recorded and automation has run.
        </p>

        {transactionNumber && (
          <div className="transaction-badge">
            <span className="transaction-label">Transaction Number</span>
            <span className="transaction-number">{transactionNumber}</span>
          </div>
        )}

        {executionStatus && (
          <div className="execution-status-row">
            <span className="execution-status-label">Automation Status</span>
            <span className={statusClass}>{executionStatus}</span>
          </div>
        )}

        <div className="confirmation-details">
          <div className="detail-row">
            <span className="detail-label">Employee</span>
            <span className="detail-value">{displayName || "—"}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">UPN</span>
            <span className="detail-value">{userPrincipalName || "—"}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Last Day</span>
            <span className="detail-value">{formatDate(lastDay)}</span>
          </div>
          {delegates && (
            <div className="detail-row">
              <span className="detail-label">Delegates</span>
              <span className="detail-value">
                {delegates
                  .split(",")
                  .map((d) => d.trim())
                  .filter(Boolean)
                  .join(", ") || "None"}
              </span>
            </div>
          )}
          <div className="detail-row">
            <span className="detail-label">Submitted</span>
            <span className="detail-value">{formatDate(dateSubmitted)}</span>
          </div>
        </div>

        {actionLog && (
          <div className="action-log">
            <div className="action-log-label">Action Log</div>
            <pre className="action-log-content">{actionLog}</pre>
          </div>
        )}

        <div className="confirmation-actions">
          <button className="btn-secondary" onClick={onViewHistory}>
            View History
          </button>
          <button className="btn-primary" onClick={onNewRequest}>
            Submit Another Request
          </button>
        </div>
      </div>
    </div>
  );
}
